import React from 'react';
import Grid from '@mui/material/GridLegacy';
import {
  Container,
  Paper,
  Typography,
  Box,
  Divider,
  Card,
  CardContent,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  Info as InfoIcon,
  Security as SecurityIcon,
  Speed as SpeedIcon,
  Support as SupportIcon,
} from '@mui/icons-material';

function AboutUs() {
  const { t } = useTranslation();
  const features = [
    {
      icon: <InfoIcon sx={{ fontSize: 32, color: '#1976d2' }} />,
      title: t('aboutUs.feature1Title'),
      description: t('aboutUs.feature1Desc')
    },
    {
      icon: <SecurityIcon sx={{ fontSize: 32, color: '#1976d2' }} />,
      title: t('aboutUs.feature2Title'),
      description: t('aboutUs.feature2Desc')
    },
    {
      icon: <SpeedIcon sx={{ fontSize: 32, color: '#1976d2' }} />,
      title: t('aboutUs.feature3Title'),
      description: t('aboutUs.feature3Desc')
    },
    {
      icon: <SupportIcon sx={{ fontSize: 32, color: '#1976d2' }} />,
      title: t('aboutUs.feature4Title'),
      description: t('aboutUs.feature4Desc')
    },
  ];

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 4, backgroundColor: '#fff' }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2, color: '#1976d2' }}>
          {t('aboutUs.pageTitle')}
        </Typography>
        <Divider sx={{ mb: 3 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            {t('aboutUs.ourMission')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'textSecondary', lineHeight: 1.8 }}>
            {t('aboutUs.missionText')}
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            {t('aboutUs.ourVision')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'textSecondary', lineHeight: 1.8 }}>
            {t('aboutUs.visionText')}
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 3, color: '#333' }}>
          {t('aboutUs.whyChooseUs')}
        </Typography>

        <Grid container spacing={3}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Card sx={{
                height: '100%',
                backgroundColor: '#f9f9f9',
                border: '1px solid #e0e0e0',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
                  borderColor: '#1976d2',
                }
              }}>
                <CardContent sx={{ display: 'flex', gap: 2 }}>
                  <Box>{feature.icon}</Box>
                  <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>
                      {feature.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'textSecondary', lineHeight: 1.6 }}>
                      {feature.description}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 4 }} />

        <Box>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            {t('aboutUs.contactInfo')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'textSecondary', lineHeight: 1.8, mb: 1 }}>
            <strong>{t('aboutUs.emailLabel')}</strong> support@ptarta-permits.com
          </Typography>
          <Typography variant="body2" sx={{ color: 'textSecondary', lineHeight: 1.8, mb: 1 }}>
            <strong>{t('aboutUs.phoneLabel')}</strong> +92-300-0000-000
          </Typography>
          <Typography variant="body2" sx={{ color: 'textSecondary', lineHeight: 1.8 }}>
            <strong>{t('aboutUs.hoursLabel')}</strong> {t('aboutUs.hoursValue')}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default AboutUs;
